import type { IContactPhone } from '@bb/contacts';
import isEmail from 'validator/es/lib/isEmail';
import isURL from 'validator/es/lib/isURL';

import { ERROR_MESSAGES } from './errors';
import type { FormValues } from './types';

const VALIDATORS: Record<keyof FormValues, (...args: any[]) => boolean> = {
  address: () => true,
  clientTags: (value?: any[]) => value && value.length > 0,
  companyAddress: () => true,
  companyName: (value?: string) => value && value.length > 0,
  email: (value?: string) => (value ? isEmail(value) : true),
  firstName: (value?: string) => value && value.length > 0,
  lastName: () => true,
  listings: () => true,
  notes: () => true,
  buyerNotifications: () => true,
  phones: (phones: IContactPhone[], index: number) => {
    const phoneNumber = phones[index]?.number.replace(/\D/g, '') ?? '';
    return Boolean(
      (phoneNumber.length >= 10 && phoneNumber.length <= 14) ||
        phoneNumber.length === 0,
    );
  },
  pronoun: () => true,
  supplierTags: (value?: any[]) => value && value.length === 1,
  website: (value?: string) => (value ? isURL(value) : true),
};

const validateFormValue = (key: keyof FormValues, ...args: any[]) => {
  try {
    const result = VALIDATORS[key](...args);

    if (result) return '';
    return ERROR_MESSAGES[key];
  } catch (err) {
    return ERROR_MESSAGES[key];
  }
};

export default validateFormValue;
